import { useTranslation } from 'react-i18next';
import styled from 'libs/styled';
import { Check } from 'assets/media/icons/Check';
import { Store } from 'assets/media/icons/Store';
import Text from 'components/Text';

const StatusWrapper = styled(Text)`
    color: var(--color-neutrals-500);
`;

const Span = styled('span')``;

const StockStatus = ({ context = 'webb', inStockStore, stockStatus = {}, isUnavailableInStore = false, ...rest }) => {
    const { t } = useTranslation();

    const { stock } = stockStatus; // leadTime, nextDelivery

    let status = 'out_of_stock';

    if (isUnavailableInStore) {
        status = 'unavailable';
    } else if (context === 'webb' || inStockStore) {
        status = 'in_stock';
    }
    const webStockText = t(`stock.${status}`, { context });
    const storeStockText = t(`stock.${status}_store`, { context });

    return (
        <StatusWrapper typography="UI/12_100_0_450" data-status={status} {...rest}>
            {context === 'webb' ? (
                <>
                    <Check
                        color={
                            status === 'in_stock' || context === 'webb'
                                ? 'var(--color-base-black)'
                                : 'var(--color-semantic-red)'
                        }
                    />
                    <Span paddingLeft="2px">{webStockText}</Span>
                </>
            ) : (
                <>
                    <Store />
                    <Span paddingLeft="2px">{storeStockText}</Span>
                </>
            )}
        </StatusWrapper>
    );
};

export default StockStatus;
